interface TransferProperty {
  fromUid: number | string;
  toUid: string;
  transferType: number;
  onSuccess: () => void;
  defaultFrom?: string;
  coin?: string;
}

const useTransfer = () => {
  const show = (params: TransferProperty) => {
    // 资产划转弹窗
    window.BybitUniFrame.ready(({ transfer }: any) => {
      console.log('transfer', params.toUid);
      const {
        VISIBILE,
        FROM_DATA,
        TO_DATA,
        TRANSFER_TYPE,
        DEFAULT_TYPE,
        DEFAULT_FROM,
        COIN,
      } = transfer.properties;
      const { HIDE_MODAL, TRANSFER_SUCCESS } = transfer.events;
      const _onSuccess = () => {
        params.onSuccess?.();
      };
      const hideModal = () => {
        transfer.setProperty(VISIBILE, false);
        transfer.unsubscribeEvent(HIDE_MODAL, hideModal);
        transfer.unsubscribeEvent(TRANSFER_SUCCESS, _onSuccess);
      };
      transfer
        .setProperty(FROM_DATA, {
          uid: params.fromUid, // 必传
        })
        .setProperty(TRANSFER_TYPE, params.transferType)
        .setProperty(DEFAULT_TYPE, 'sub')
        .subscribeEvent(HIDE_MODAL, hideModal)
        .subscribeEvent(TRANSFER_SUCCESS, _onSuccess)
        .setProperty(COIN, params.coin || '')
        .setProperty(DEFAULT_FROM, params.defaultFrom || '');
      if (params.toUid) {
        transfer.setProperty(TO_DATA, { uid: params.toUid });
      }
      transfer.setProperty(VISIBILE, true);
    });
  };

  return {
    showTransferModal: show,
  };
};

export default useTransfer;
